import React, { useState } from 'react';
import AccountBalance from '../../components/trading/AccountBalance';
import OrderHistory from '../../components/trading/OrderHistory';
import OrderTicket from '../../components/trading/OrderTicket';
import { ShoppingCart } from 'lucide-react';

const Orders: React.FC = () => {
  const [ticketOpen, setTicketOpen] = useState(false);
  const [ticketSymbol, setTicketSymbol] = useState('');
  const [symbolInput, setSymbolInput] = useState('');
  const [showSymbolInput, setShowSymbolInput] = useState(false);

  function openTicket(symbol?: string) {
    if (symbol) {
      setTicketSymbol(symbol);
      setTicketOpen(true);
    } else {
      setShowSymbolInput(true);
    }
  }

  function handleSymbolSubmit(e: React.FormEvent) {
    e.preventDefault();
    const sym = symbolInput.trim().toUpperCase();
    if (sym) {
      setTicketSymbol(sym);
      setTicketOpen(true);
      setShowSymbolInput(false);
      setSymbolInput('');
    }
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-6 space-y-6">
      {/* Page header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-slate-100">Orders</h1>
          <p className="text-sm text-slate-400 mt-0.5">Track your submitted buy/sell orders</p>
        </div>
        <button
          onClick={() => openTicket()}
          className="flex items-center gap-2 px-4 py-2 bg-teal-600 hover:bg-teal-500 text-white text-sm font-semibold rounded-lg transition-colors"
        >
          <ShoppingCart size={14} />
          New Order
        </button>
      </div>

      {/* Inline symbol prompt */}
      {showSymbolInput && (
        <form
          onSubmit={handleSymbolSubmit}
          className="flex items-center gap-3 bg-slate-800/60 border border-slate-700/50 rounded-xl p-4"
        >
          <label className="text-sm text-slate-400 whitespace-nowrap">Symbol:</label>
          <input
            type="text"
            value={symbolInput}
            onChange={(e) => setSymbolInput(e.target.value)}
            placeholder="e.g. AAPL"
            autoFocus
            className="flex-1 bg-slate-700 border border-slate-600 text-slate-100 text-sm rounded-lg px-3 py-2 focus:outline-none focus:border-teal-500"
          />
          <button
            type="submit"
            className="px-4 py-2 bg-teal-600 hover:bg-teal-500 text-white text-sm font-semibold rounded-lg transition-colors"
          >
            Continue
          </button>
          <button
            type="button"
            onClick={() => setShowSymbolInput(false)}
            className="px-3 py-2 text-slate-400 hover:text-slate-200 text-sm rounded-lg transition-colors"
          >
            Cancel
          </button>
        </form>
      )}

      {/* Account balance */}
      <AccountBalance />

      {/* Order history */}
      <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-5">
        <h2 className="text-sm font-semibold text-slate-300 mb-4">Order History</h2>
        <OrderHistory onPlaceOrder={() => openTicket()} />
      </div>

      {/* Order ticket modal */}
      <OrderTicket
        symbol={ticketSymbol}
        currentPrice={0}
        isOpen={ticketOpen}
        onClose={() => setTicketOpen(false)}
      />
    </div>
  );
};

export default Orders;
